function escapeHtml(value) {
  return String(value ?? "").replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;").replaceAll("'", "&#39;");
}

function formatDate(value) {
  return new Date(`${value}T12:00:00Z`).toLocaleDateString("en-US", {
    month: "short", day: "numeric", year: "numeric", timeZone: "UTC",
  });
}

// Shared by the browser page and build-time HTML, so the crawler sees the
// same dated age comparison and source links that readers see after loading.
export function renderBlogAgeTable(post) {
  if (!post.ageTable) return "";
  return `<section class="blog-age-table" aria-labelledby="cast-age-table-title">
    <div class="blog-age-table-header"><h2 id="cast-age-table-title">${escapeHtml(post.ageTable.title)}</h2></div>
    <table class="blog-age-data">
      <thead><tr><th scope="col">Actor / birthday source</th><th scope="col">Role / reference date</th><th scope="col">Age</th></tr></thead>
      <tbody>${post.ageTable.rows.map((row) => `<tr>
        <th scope="row"><a href="${escapeHtml(row.sourceUrl)}">${escapeHtml(row.actor)}</a><small>Born <time datetime="${escapeHtml(row.dob)}">${formatDate(row.dob)}</time></small></th>
        <td>${escapeHtml(row.character)}<small><time datetime="${escapeHtml(row.date)}">${formatDate(row.date)}</time>${row.episodeTitle ? ` · ${row.episodeHref ? `<a data-link href="${escapeHtml(row.episodeHref)}">${escapeHtml(row.episodeTitle)}</a>` : escapeHtml(row.episodeTitle)}` : ""}${row.note ? `<br>${escapeHtml(row.note)}` : ""}</small></td>
        <td class="blog-age-num">${escapeHtml(row.age)}</td>
      </tr>`).join("")}</tbody>
    </table>
  </section>`;
}

export function renderBlogSources(post) {
  if (!post.sources?.length) return "";
  return `<section class="blog-sources" aria-labelledby="article-sources-title">
    <h2 id="article-sources-title">Sources and date notes</h2>
    <p>The linked actor names in the table lead to the biographical birth-date references. These sources establish the broadcast and casting context:</p>
    <ul>${post.sources.map((entry) => `<li><a href="${escapeHtml(entry.url)}">${escapeHtml(entry.label)}</a>${entry.note ? ` — ${escapeHtml(entry.note)}` : ""}</li>`).join("")}</ul>
  </section>`;
}
